import React from "react";
import { BCMSRecord, ModalOpen, useParams, useRoute, useBCMSContext, useWorkflowStep, useBCMSModal } from "@bcm-dev/bcms-vite";
import { Card } from "model";
import { getWorkflowSteps, getDefault } from "components/workflows/BalanceTransferWorkflow";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import { TransferReviewDetails } from "../TransferReviewDetails";

/**
 * @function TransferReviewDetailsView
 * @return {React.Component}
 * @exported true
 * @description The main component for TransferReviewDetailsView
 */
export default function TransferReviewDetailsView(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor([ Card ], globalController);
  const cardID = useParams().cardID ?? "0";
  const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
  const state = workflowStep.getStepState;

  const next = evt => workflowStep.workflow.nextStep();
  const prev = evt => workflowStep.workflow.prevStep();

  const navigate = useRoute();
  const { close } = useBCMSModal();
  const yesClicked = () => {
    close("CancelBalanceTransferModal");
    navigate(-3);
  }

  return (
    <div className="transfer-review-details-view">
      <div className="content-container text-center">
        <b>Review Transfer Details</b>
      </div>
      <div className="content-container">
        <p>Carefully review the transfer details as they cannot be changed once the request is submitted.</p>
      </div>
      <TransferReviewDetails form={ state } />
      <div className="flex-container flex-vertical align-center-container content-container">
        <UICancelButton text="Edit Details" onClick={ prev } />
      </div>
      <div className="flex-container flex-vertical align-center-container content-container">
        <UIPrimaryButton text="Submit" onClick={ next } />
        <ModalOpen id="CancelBalanceTransferModal" data= { {yesClicked: yesClicked} }>
          <UICancelButton text="Cancel" />
        </ModalOpen>
      </div>
    </div>
  )
}

